import { Component } from '@angular/core';

@Component({
  selector: 'app-diamond',
  template: `
    <div class="center">

    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.2188 7.71328L14.8438 2.71328C14.7853 2.64647 14.7132 2.59289 14.6324 2.55612C14.5516 2.51934 14.4639 2.50021 14.3751 2.5H5.62506C5.53626 2.50021 5.44852 2.51934 5.36769 2.55612C5.28687 2.59289 5.2148 2.64647 5.15631 2.71328L0.781307 7.71328C0.679243 7.82981 0.624089 7.98009 0.626543 8.13498C0.628997 8.28987 0.688883 8.43832 0.794588 8.55156L9.54459 17.9266C9.60307 17.9893 9.67382 18.0392 9.75245 18.0734C9.83107 18.1076 9.91589 18.1252 10.0016 18.1252C10.0874 18.1252 10.1722 18.1076 10.2508 18.0734C10.3294 18.0392 10.4002 17.9893 10.4587 17.9266L19.2087 8.55156C19.3139 8.43793 19.3732 8.28926 19.3751 8.13438C19.377 7.97949 19.3213 7.82943 19.2188 7.71328ZM17.3727 7.5H14.0626L11.2501 3.75H14.0915L17.3727 7.5ZM5.82662 8.75L8.18053 14.6352L2.68834 8.75H5.82662ZM12.8266 8.75L10.0001 15.8172L7.17349 8.75H12.8266ZM7.50006 7.5L10.0001 4.16641L12.5001 7.5H7.50006ZM14.1735 8.75H17.3118L11.8196 14.6352L14.1735 8.75ZM5.90865 3.75H8.75006L5.93756 7.5H2.6274L5.90865 3.75Z" fill="white" />
    </svg>
  
    </div>`,
  styleUrls: ['./center.style.css'],
})
export class DiamondComponent {}
